module.exports = __webpack_public_path__ + "static/media/mainLogo.b5d4b54a.png";